<template>
  <nav class="flex" aria-label="Breadcrumb">
    <ol class="flex items-center space-x-2">
      <li v-for="(item, index) in items" :key="index" class="flex items-center">
        <!-- Home icon for first item -->
        <HomeIcon 
          v-if="index === 0 && item.icon !== false"
          class="w-4 h-4 text-gray-400 mr-2"
        />
        
        <!-- Breadcrumb item -->
        <div class="flex items-center">
          <!-- Link item -->
          <router-link
            v-if="item.to && index < items.length - 1"
            :to="item.to"
            class="text-sm font-medium text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:text-gray-300 transition-colors duration-150"
          >
            {{ item.label }}
          </router-link>
          
          <!-- Current page (not a link) -->
          <span
            v-else
            class="text-sm font-medium"
            :class="index === items.length - 1 ? 'text-gray-900 dark:text-white' : 'text-gray-500 dark:text-gray-400'"
          >
            {{ item.label }}
          </span>
        </div>
        
        <!-- Separator -->
        <ChevronRightIcon
          v-if="index < items.length - 1"
          class="w-4 h-4 text-gray-400 mx-2"
        />
      </li>
    </ol>
  </nav>
</template>

<script setup>
import { HomeIcon, ChevronRightIcon } from '@heroicons/vue/24/outline'

defineProps({
  items: {
    type: Array,
    required: true,
    validator: (items) => {
      return items.every(item => 
        typeof item === 'object' && 
        typeof item.label === 'string'
      )
    }
  }
})
</script>

<style scoped>
/* Custom hover effects */
a:hover {
  text-decoration: none;
}
</style>